import { Component } from '@angular/core';
import { SkeletonComponent } from '@orderna/admin-panel/src/app/shared/components/skeleton/skeleton.component';

@Component({
  selector: 'app-pos-transaction-controls-skeleton',
  standalone: true,
  imports: [SkeletonComponent],
  templateUrl: './transaction-controls-skeleton.component.html',
})
export class TransactionControlsSkeletonComponent {
}
